// a mapping of constants to cookie names

export const ClientStorage = {
  COOKIE_REGION: "geo",
  COOKIE_REGION_OVERRIDE: "geo_debug",
  COOKIE_ACCEPT_LANGUAGE: "lang",
  COOKIE_ACCEPT_LANGUAGE_OVERRIDE: "lang_debug",
  LOCALSTORAGE_DEFINED_LANGUAGE: "riotgames.localStorageLanguageSelectOverride",
};
